export default {
    changeShowEmpty(state,param) {
        state.showEmpty=param
    },
    changeIsMobile(state,params) {
        state.isMobile=params
    }
}